import { BoxTitles } from "@boxes/BoxTitles";
import { BaseCurrencyInput, Button, Drawer, Radio, Select } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/filtered-audience.module.scss";

export const TotalSpendFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [controllerInputs, setControllerInputs] = useState(getInputType(node));
  const [controllerInputsDate, setControllerInputsDate] = useState(
    node.data?.inLast !== undefined ? "custom-days" : "all-days"
  );

  const [min, setMin] = useState(node.data.min || null);
  const [max, setMax] = useState(node.data.max || null);
  const [exact, setExact] = useState(node.data.exact || null);
  const [inLast, setInLast] = useState(node.data.inLast || null);
  const [inLastPeriod, setInLastPeriod] = useState(
    node.data.inLastPeriod || "DAY"
  );

  const [inclusive, setInclusive] = useState(
    node.data.inclusive !== undefined ? !!node.data.inclusive : true
  );

  const getFreshNode = () => {
    const dataValue = {
      ...(node?.data || {}),
      min,
      max,
      exact,
      inLast,
      inLastPeriod,
      inclusive,
    };

    switch (controllerInputs) {
      case "range":
        dataValue.exact = undefined;
        break;
      case "minimum":
        dataValue.exact = undefined;
        dataValue.max = undefined;
        break;
      case "exact":
        dataValue.min = undefined;
        dataValue.max = undefined;
        break;
    }

    if (controllerInputsDate == "all-days") {
      dataValue.inLast = undefined;
      dataValue.inLastPeriod = undefined;
    }

    return {
      ...node,
      data: dataValue,
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [min, max, exact, inLast, inLastPeriod]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.TotalSpendConditional}
    >
      <p className={styles.label}>Defina a faixa de total gasto</p>

      <Radio
        text="Faixa de total gasto"
        family="CustomerAverageTicket"
        className="mb-15"
        value="range"
        checked={controllerInputs}
        onChange={() => setControllerInputs("range")}
      />

      {controllerInputs === "range" && (
        <div className="mb-20 d-flex align-center">
          <BaseCurrencyInput
            className="w-100 mr-15"
            value={min}
            onChange={(v) => setMin(v)}
          />
          <BaseCurrencyInput
            className="w-100"
            value={max}
            onChange={(v) => setMax(v)}
          />
        </div>
      )}

      <Radio
        text="Mínimo de total gasto"
        family="CustomerAverageTicket"
        className="mb-15"
        value="minimum"
        checked={controllerInputs}
        onChange={() => setControllerInputs("minimum")}
      />

      {controllerInputs === "minimum" && (
        <BaseCurrencyInput
          className="w-100 mb-20"
          value={min}
          onChange={(v) => {
            setMin(v);
          }}
        />
      )}

      <Radio
        text="Total gasto exato"
        family="CustomerAverageTicket"
        className="mb-15"
        value="exact"
        checked={controllerInputs}
        onChange={() => setControllerInputs("exact")}
      />

      {controllerInputs === "exact" && (
        <BaseCurrencyInput
          className="w-100"
          value={exact}
          onChange={(v) => {
            setExact(v);
          }}
        />
      )}

      <div className={styles.hairlineB} />

      <p className={styles.label}>Determine o tempo</p>

      <Radio
        text="Todo o período"
        family="time"
        value="all-days"
        checked={controllerInputsDate}
        className="mb-15"
        onChange={() => setControllerInputsDate("all-days")}
      />

      <Radio
        text="Período personalizado"
        family="time"
        value="custom-days"
        checked={controllerInputsDate}
        className="mb-15"
        onChange={() => setControllerInputsDate("custom-days")}
      />

      {controllerInputsDate === "custom-days" && (
        <>
          <div className={styles.customPeriod}>
            <p>Nos últimos</p>

            <div className="d-flex mb-20">
              <BaseCurrencyInput
                placeholder="Inserir valor"
                className="w-50"
                precision={0}
                prefix=""
                type="tel"
                value={inLast}
                onChange={(v) => setInLast(v)}
              />
              <Select
                title="Selecione o tempo..."
                className="w-50 ml-15"
                value={inLastPeriod}
                options={[
                  { label: "Dias", value: "DAY" },
                  { label: "Meses", value: "MONTH" },
                  { label: "Anos", value: "YEAR" },
                ]}
                onChange={(e) => setInLastPeriod(e.target.value)}
              />
            </div>
          </div>
        </>
      )}

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};

const getInputType = (node) => {
  const { data } = node || {};
  if (data?.exact !== null && data?.exact !== undefined) {
    return "exact";
  } else if (data?.max !== null && data?.max !== undefined) {
    return "range";
  } else if (data?.min !== null && data?.min !== undefined) {
    return "minimum";
  } else {
    return "range";
  }
};
